import { AxiosInstance } from "axios"
import { GDPRFiles, GDPRUserDeletionPeriod, UserByDomain, UsersByDomainReportDetails } from "./gdprTypes"
import { mapDeletionPeriodToDays } from "./helpers/mapEnumValuesToParams"

type GDPRFilesResponse = Readonly<{
    gdprFiles: Array<GDPRFiles>
}>

type FetchVerifiedDomainsParams = Readonly<{ supplierId: number }>

type GDPRVerifiedDomainsResponse = Readonly<{
    domains: Array<string>
}>

type FetchGDPRUsersByDomainParams = Readonly<{
    supplierId: number
    userTypes: string[]
    includeDeletedUsers: boolean
    periodInDays?: GDPRUserDeletionPeriod
}>

export type GDPRUsersByDomainResponse = Readonly<{
    reportDetails: UsersByDomainReportDetails
    users: Array<UserByDomain>
}>

export enum GDPRFilesQuery {
    GDPR_FILES_LIST = "gdpr-files-list",
    GDPR_VERIFIED_DOMAINS = "gdpr-verified-domains",
}

export async function fetchGDPR({}, axios: AxiosInstance, signal?: AbortSignal): Promise<GDPRFilesResponse> {
    const url = "/gdpr/files"

    const response = await axios.get(url, { signal })

    return response.data
}

export async function fetchGDPRVerifiedDomains(
    { supplierId }: FetchVerifiedDomainsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GDPRVerifiedDomainsResponse> {
    const url = `suppliers/${supplierId}/gdpr/verifiedDomains`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function fetchGDPRUsersByDomain(
    params: FetchGDPRUsersByDomainParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<GDPRUsersByDomainResponse> {
    const { supplierId, periodInDays, userTypes, ...rest } = params

    const url = `/suppliers/${supplierId}/gdpr/export/users`

    const queryParams = {
        ...rest,
        userType: userTypes.join(","),
        ...(params.includeDeletedUsers &&
            periodInDays !== undefined && { periodInDays: mapDeletionPeriodToDays(periodInDays) }),
    }

    const response = await axios.get(url, {
        params: queryParams,
        signal,
    })

    return response.data
}
